import { render, staticRenderFns } from "./SpecialAmexGeoBanner.vue?vue&type=template&id=55270be7&scoped=true&"
import script from "./SpecialAmexGeoBanner.vue?vue&type=script&lang=js&"
export * from "./SpecialAmexGeoBanner.vue?vue&type=script&lang=js&"
import style0 from "./SpecialAmexGeoBanner.vue?vue&type=style&index=0&id=55270be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55270be7",
  null
  
)

export default component.exports